class WardModel{
    wardId:number;   
    name?: string;
    
   
}

export default WardModel